/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EventRuleSyntax } from '../../../../Services/event-bus/src/EventBus.service.defs';
import { AttributeRule } from '../../forms/EventSubscriptionBuilderForm/EventSubscriptionBuilderForm.defs';

/**
 * Converts the attribute filter into the syntax compatible with the Event Bus service.
 * @param {AttributeRule} operation The attribute filter rule.
 * @param {string} value The attribute filter value.
 * @export
 * @returns {string} The event pattern syntax which represents the attribute filter.
 */
export const convertToEventSyntax = (operation: AttributeRule, value = ''): EventRuleSyntax => {
  /* eslint-disable default-case */

  switch (operation) {
    case AttributeRule.Equals: {
      const valueNumber = Number(value);
      if (!isNaN(valueNumber)) {
        return [{ numeric: ['=', valueNumber] }];
      }

      return [value as string];
    }

    case AttributeRule.NotEquals: {
      return [{ 'anything-but': [value] }];
    }

    case AttributeRule.LessThan: {
      return [{ numeric: [AttributeRule.LessThan, Number(value)] }];
    }

    case AttributeRule.LessThanEquals: {
      return [{ numeric: [AttributeRule.LessThanEquals, Number(value)] }];
    }

    case AttributeRule.GreaterThan: {
      return [{ numeric: ['>', Number(value)] }];
    }

    case AttributeRule.GreaterThanEquals: {
      return [{ numeric: [AttributeRule.GreaterThanEquals, Number(value)] }];
    }

    case AttributeRule.BeginsWith: {
      return [{ prefix: value }];
    }

    case AttributeRule.Exists: {
      return [{ exists: true }];
    }

    case AttributeRule.NotExists: {
      return [{ exists: false }];
    }

    case AttributeRule.IsNull: {
      return [null];
    }

    case AttributeRule.IsEmpty: {
      return [''];
    }
  }
};
